import { Box, Stack, Typography } from '@mui/material';

import { useDeviceType } from '@app/hooks/useBrowserHooks';

interface ProgressStepperProps {
  activeStep: number;
}

export const ProgressStepper = ({ activeStep }: ProgressStepperProps) => {
  const { isMobile, isDesktop } = useDeviceType();
  const arrowWidth = isMobile ? '25px' : '35px';
  const steps = !isMobile
    ? [
        { id: 1, label: '情報の入力', title: 'STEP.01' },
        { id: 2, label: '希望日時の入力', title: 'STEP.02' },
        { id: 3, label: '入力内容の確認', title: 'STEP.03' },
      ]
    : [
        { id: 1, label: '01', title: 'STEP.' },
        { id: 2, label: '02', title: 'STEP.' },
        { id: 3, label: '03', title: 'STEP.' },
      ];

  return (
    <Box
      component="ul"
      sx={{
        display: 'flex',
        listStyle: 'none',
        m: 0,
        p: 0,
        width: '100%',
      }}
    >
      {steps.map((step, index) => {
        const isFirst = index === 0;
        const isLast = index === steps.length - 1;
        const isActive = index === activeStep;
        return (
          <Stack
            key={step.id}
            component="li"
            color={isActive ? '#fff' : '#000'}
            flex={1}
            flexDirection="column"
            justifyContent="left"
            ml={isFirst ? 0 : isMobile ? '-21px' : '-31px'}
            position="relative"
            py={{ md: '1.2vw', xs: 1.2 }}
            whiteSpace="nowrap"
            zIndex={steps.length - index}
            sx={{
              backgroundColor: isActive ? '#3187E1' : '#DEF0FA',
              clipPath: isFirst
                ? `polygon(0 0, calc(100% - ${arrowWidth}) 0, 100% 50%, calc(100% - ${arrowWidth}) 100%, 0 100%)`
                : isLast
                ? `polygon(0 0, 100% 0, 100% 50%, 100% 100%, 0 100%, ${arrowWidth} 50%)`
                : `polygon(0 0, calc(100% - ${arrowWidth}) 0, 100% 50%, calc(100% - ${arrowWidth}) 100%, 0 100%, ${arrowWidth} 50%)`,
            }}
          >
            <Box pl={isFirst ? 2 : 5.5}>
              <Typography
                component="span"
                color={isActive ? '#ffffff' : '#000000'}
                display="block"
                fontWeight="bold"
                lineHeight={{ md: 1.5, xs: 1 }}
                textAlign="left"
              >
                {step.title}
              </Typography>
            </Box>
            <Box pl={isFirst ? 2 : 5.5}>
              <Typography
                color={isActive ? '#ffffff' : '#000000'}
                display="block"
                fontWeight="bold"
                lineHeight={{ md: 1.5, xs: 1 }}
                textAlign="left"
                variant={isDesktop ? 'h4' : undefined}
                component="span"
              >
                {step.label}
              </Typography>
            </Box>
          </Stack>
        );
      })}
    </Box>
  );
};
